import { api } from '@marketplace-web/core-api/core-api-client-util'

import {
  BusinessAccountInvoiceInstructionsResp,
  GetBusinessAccountInvoiceInstructionsArgs,
} from '../types/transactions'

export const getBusinessAccountInvoiceInstructions = ({
  transactionId,
}: GetBusinessAccountInvoiceInstructionsArgs) =>
  api.get<BusinessAccountInvoiceInstructionsResp>(
    `transactions/${transactionId}/business_account_invoice_instructions`,
  )
